import { get } from '@/api/client'

export interface PsiAccessCurrentResponse {
  enabled: boolean
  companyId: number
  env: string
}

export function getCurrentPsiAccess() {
  return get<PsiAccessCurrentResponse>('/business/psiAccess/current')
}
